import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, subscribed: false, permission: 'unsupported' };
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return { supported: true, subscribed: !!sub, permission: Notification.permission };
  } catch {
    return { supported: true, subscribed: false, permission: Notification.permission };
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error('Notifications are not supported on this device/browser.');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission was not granted.');

  const { data } = await axios.get(`${API}/vendor/push/public-key`);
  if (!data.public_key) throw new Error('Push is not configured on the server.');

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const token = localStorage.getItem('vendor_token');
  await axios.post(`${API}/vendor/push/subscribe`, { subscription: sub.toJSON() }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const token = localStorage.getItem('vendor_token');
    try {
      await axios.post(`${API}/vendor/push/unsubscribe`, { subscription: sub.toJSON() }, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch { /* ignore */ }
    await sub.unsubscribe();
  }
}
